// External Dependencies:
import React from 'react'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import Image from 'church-theme-library/components/Image/Image'

class OurChurch extends React.Component {
	render() {
		return (
			<div className="section-our-church">
				<div className="-inner">

				</div>
			</div>
		)
	}
}

export default OurChurch
